export default __webpack_public_path__ + "static/media/ctg-1a.179b03dd.webp";